/* assets/mm-swirl.js — Mobile-Tuning für Swirl-Hintergründe (snippets/mm-swirl-background.liquid)
 * Auf kleinen Screens: numOctaves 2 (GPU-schonend) und optionale Mobile-Werte aus data-Attributen.
 * Optional „Sanft animieren“ (data-animate): seed langsam wechseln, nicht bei prefers-reduced-motion. */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 767px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function tune(el) {
    var turb = el.querySelector('feTurbulence'); if (!turb) return;
    var map = el.querySelector('feDisplacementMap');
    if (mq.matches) {
      turb.setAttribute('numOctaves', '2');
      if (el.dataset.mobileBf) turb.setAttribute('baseFrequency', el.dataset.mobileBf);
      if (el.dataset.mobileScale && map) map.setAttribute('scale', el.dataset.mobileScale);
    } else {
      if (el.dataset.octaves) turb.setAttribute('numOctaves', el.dataset.octaves);
      if (el.dataset.bf) turb.setAttribute('baseFrequency', el.dataset.bf);
      if (el.dataset.scale && map) map.setAttribute('scale', el.dataset.scale);
    }
    if (el.dataset.animate === 'true' && !reduce.matches && !el._mmAnim) {
      var seed = parseInt(turb.getAttribute('seed'), 10) || 7;
      el._mmAnim = window.setInterval(function () { seed = (seed % 100) + 1; turb.setAttribute('seed', String(seed)); }, 4000);
    }
  }
  function init(root) { (root || document).querySelectorAll('[data-mm-swirl][data-mode="swirl"]').forEach(tune); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  mq.addEventListener && mq.addEventListener('change', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
